import { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";

//Icons
import { MdEdit } from "react-icons/md";

//UI components
import Field from "../../../ui/Field";

//Utils
import currencyFormatToEUR from "../../../utils/currencyFormatToEUR";
import tooltipsText from "../../../utils/tooltipsText";

//Components
import RealiziranaVrednostProjektaEditForm from "./RealiziranaVrednostProjektaEditForm";

//API calls
import { useGetRealiziraneVrednostiProjekta } from "../../../../services/ProjectDetails/financeAPI";

// Auth
import RoleGuard from "../../../../auth/RoleGuard";
import { MODULES, ROLE_GROUPS } from "../../../../auth/roles";

// Context
import { useProjectDetailsContext } from "../../../../context/ProjectDetailsContext";

const FinanceSkupniPodatkiRealizirano = () => {
  const { id } = useParams();
  const [isEditing, setIsEditing] = useState(false);
  const { project } = useProjectDetailsContext();

  const { data: realiziraneVrednosti, isLoading } =
    useGetRealiziraneVrednostiProjekta(id);

  if (isLoading) {
    return (
      <div className="mb-3 mt-3">
        <h6 className="form-section-heading">Celoten projekt</h6>
        <p>Nalaganje...</p>
      </div>
    );
  }

  // Format lastno sofinanciranje to include both the value and the percentage in parentheses
  const lastnoSofinanciranjeInDelez = `${currencyFormatToEUR(
    realiziraneVrednosti?.realiziranaLastnaVrednost,
    true,
  )} (${realiziraneVrednosti?.realiziranaDelez ? `${realiziraneVrednosti.realiziranaDelez}%` : "Ni podatka o deležu"})`;

  return (
    <Row>
      <Col md={5}>
        <h6 className="form-section-heading">Celoten projekt</h6>
        {!isEditing && (
          <>
            <Field
              label="Vrednost projekta"
              value={currencyFormatToEUR(
                realiziraneVrednosti?.realiziranaVrednost,
              )}
              tooltip={tooltipsText.P42vrednostProjekta}
            />

            <Field
              label="Sofinanciranje iz projektnega vira"
              value={currencyFormatToEUR(
                realiziraneVrednosti?.realiziraniProjektniViri,
              )}
              tooltip={tooltipsText.P42vrednostSofinanciranjaIzProjektnihVirov}
            />
          </>
        )}
        {isEditing && (
          <RealiziranaVrednostProjektaEditForm
            setIsEditing={setIsEditing}
            realiziraneVrednosti={realiziraneVrednosti}
          />
        )}
      </Col>
      <Col md={5}>
        <h6 className="form-section-heading">Podatki ki se nanašajo na UM</h6>
        <Field
          label="Vrednost projekta"
          value={currencyFormatToEUR(
            realiziraneVrednosti?.realiziranaVrednostUM,
            true,
          )}
          tooltip={tooltipsText.P42vrednostProjektaZaUM}
        />
        <Field
          label="Lastno sofinanciranje"
          value={lastnoSofinanciranjeInDelez}
          tooltip={tooltipsText.P42VrednostDelezLastnegaSofinanciranjaUM}
        />
        <Field
          label="Sofinanciranje iz projektnega vira"
          value={currencyFormatToEUR(
            realiziraneVrednosti?.realiziranaVrednostViri,
            true,
          )}
          tooltip={tooltipsText.P42vrednostSofinanciranjaIzProjektnihVirovZaUM}
        />
        <Field
          label="Obseg zaposlitev (izraženo v FTE)"
          value={
            realiziraneVrednosti?.realiziranaObseg
              ? `${realiziraneVrednosti.realiziranaObseg}`
              : "Nepopolni podatki"
          }
          tooltip={tooltipsText.P42obsegZaposlitveFTE}
        />
      </Col>
      <Col md={2} className="d-flex justify-content-md-end align-items-start ">
        {!isEditing && (
          <RoleGuard
            moduleKey={MODULES.PROJEKTI}
            roles={ROLE_GROUPS.EDITORS_AND_SKRBNIK}
            vodilnaClanicaProjektaID={project?.clanicaID}
          >
            <button
              type="button"
              className="btn btn-sm btn-outline-primary uredi-btn-tab-card-header border-0"
              onClick={() => setIsEditing(true)}
            >
              <span className="d-flex align-items-center gap-1">
                Uredi <MdEdit />
              </span>
            </button>
          </RoleGuard>
        )}
      </Col>
    </Row>
  );
};

export default FinanceSkupniPodatkiRealizirano;
